/**
 * Cura — Team Slider
 * Desktop: JS translate-based sliding, 4 cards per view, arrow navigation.
 * Mobile: native CSS scroll (JS disabled, track-wrap becomes overflow-x:auto).
 */
(function () {
  'use strict';

  var CARDS_DESKTOP = 4;
  var CARDS_TABLET  = 2;
  var GAP_PX        = 20; // must match CSS gap (2rem @ 10px base)

  function isMobile() { return window.innerWidth <= 749; }
  function isTablet()  { return window.innerWidth >= 750 && window.innerWidth <= 989; }

  class CuraTeamSlider {
    constructor(section) {
      this.section   = section;
      this.track     = section.querySelector('[data-ts-track]');
      this.cards     = Array.from(section.querySelectorAll('[data-ts-card]'));
      this.prevBtn   = section.querySelector('[data-ts-prev]');
      this.nextBtn   = section.querySelector('[data-ts-next]');
      this.current   = 0; // index of leftmost visible card
      this.total     = this.cards.length;

      if (!this.track || this.total === 0) return;

      this.bindEvents();
      this.update();

      window.addEventListener('resize', () => this.update());
    }

    visibleCount() {
      if (isTablet())  return CARDS_TABLET;
      if (isMobile())  return null; // native scroll
      return CARDS_DESKTOP;
    }

    maxIndex() {
      var vis = this.visibleCount();
      if (!vis) return 0;
      return Math.max(0, this.total - vis);
    }

    goTo(index) {
      if (isMobile()) return;
      this.current = Math.max(0, Math.min(index, this.maxIndex()));
      this.applyTransform();
      this.updateButtons();
    }

    applyTransform() {
      if (isMobile() || !this.cards.length) return;
      var cardWidth  = this.cards[0].offsetWidth;
      var offset     = this.current * (cardWidth + GAP_PX);
      this.track.style.transform = 'translateX(-' + offset + 'px)';
    }

    update() {
      if (isMobile()) {
        // Reset JS transform — native scroll takes over
        this.track.style.transform = '';
        this.current = 0;
        return;
      }
      // Clamp current in case window resized
      this.current = Math.min(this.current, this.maxIndex());
      this.applyTransform();
      this.updateButtons();
    }

    updateButtons() {
      if (this.prevBtn) this.prevBtn.disabled = this.current === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.current >= this.maxIndex();
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.goTo(this.current - 1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.goTo(this.current + 1));
      }

      // Keyboard
      this.section.addEventListener('keydown', (e) => {
        if (isMobile()) return;
        if (e.key === 'ArrowLeft')  this.goTo(this.current - 1);
        if (e.key === 'ArrowRight') this.goTo(this.current + 1);
      });
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-ts-slider]').forEach(function (el) {
      var section = el.closest('section') || el;
      if (!section.dataset.tsInit) {
        new CuraTeamSlider(section);
        section.dataset.tsInit = 'true';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();